export default __webpack_public_path__ + "static/media/img-logo-victoropts.cc895b30.svg";